module.exports = __webpack_public_path__ + "media/images/icon_list/sort-2665aca582126aa508098c9679802f4e.svg";